import { styled, createGlobalStyle, css } from 'styled-components';
import { BREAKPOINTS } from '../../../constants/layout.mjs';
import { theme } from '../../../constants/theme.mjs';
import '../../Badge/index.mjs';
import '../../Button/index.mjs';
import '../../StyleableSvgImage/index.mjs';
import './CompareTableMarkup/components/StickyGrid/index.mjs';
import { StickyGridItem } from './CompareTableMarkup/components/StickyGrid/StickyGridItem.mjs';
import { Badge as Badge$1 } from '../../Badge/Badge.mjs';
import { StyleableSvgImage } from '../../StyleableSvgImage/StyleableSvgImage.mjs';
import { Button as Button$1 } from '../../Button/Button.mjs';
"use strict";
const MOBILE_BREAKPOINT = 650;
const TOOLTIP_CLASS_NAME = `model-compare-tooltip`;
const PRODUCT_HEADER_TOOLTIP_CLASSNAME = "model-compare-product-header-tooltip";
const PlaceholderGridItem = styled(StickyGridItem)`
  background: ${theme.colors.white};
  z-index: 3;
`;
const CenterPlaceholderGridItem = styled(StickyGridItem)``;
const HEADER_GRID_ITEM_Y_PADDING = 16;
const HEADER_GRID_ITEM_GAP_DESKTOP = 24;
const HEADER_GRID_ITEM_GAP_MOBILE = 12;
const ProductHeaderTooltipStyles = createGlobalStyle`
  .${PRODUCT_HEADER_TOOLTIP_CLASSNAME} {
    box-shadow: 0 8px 24px 0 #00000014;
    width: 175px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    padding: 10px 20px;
    margin-top: -1.5px;
    background: white;
    text-align: center;

    &::before {
      box-shadow: 0 8px 24px 0 #00000014;
      background: white;
    }
  }
`;
const ProductHeaderTooltipHoverArea = styled.div`
  position: absolute;
  ${({
  $tooltipIsPositionedTop
}) => $tooltipIsPositionedTop ? css`
          bottom: 0;
        ` : css`
          top: 0;
        `}
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  width: ${({
  $width
}) => $width ?? 175}px;
  height: 40px;
`;
const ProductHeaderTooltipLink = styled.a`
  color: ${theme.colors.primaryBlue};

  &:hover {
    color: ${theme.colors.primaryBlue};
  }
`;
const HeaderGridItem = styled(StickyGridItem)`
  background: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  padding: ${HEADER_GRID_ITEM_Y_PADDING}px 0;
  gap: ${HEADER_GRID_ITEM_GAP_DESKTOP}px;
  position: relative;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    gap: ${HEADER_GRID_ITEM_GAP_MOBILE}px;
    /* Need this padding-top so sticky offset looks good on mobile */
    padding: 25px 0 0;
  }
`;
const EmptyHeaderGridItem = styled(HeaderGridItem)`
  align-items: center;
  justify-content: center;
`;
const EmptyHeaderEmptyProductDescription = styled.div`
  width: 100%;
  height: 100%;

  ${({
  $headerItemsAreSticking
}) => $headerItemsAreSticking && css`
      display: none;
    `}
`;
const HeaderGridItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const RemoveProductButton = styled.button`
  position: absolute;
  top: 25px;
  right: 25px;
  background: transparent;
  border: none;
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  color: #c2c6cb;

  ${({
  $isSmallScreen
}) => $isSmallScreen && css`
      top: 0;
      right: 4%;
    `}
`;
const ProductMeta = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  width: 100%;
  padding: 0 10px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  }
`;
const productTitleStyles = css`
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.32px;
`;
const ProductTitle = styled.div`
  ${productTitleStyles}

  color: ${theme.colors.black};

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 14px;
  }
`;
const ProductTitleLink = styled.button`
  ${productTitleStyles}
  color: ${theme.colors.primaryBlue};
  border: none;
  background: transparent;

  :focus,
  :hover {
    text-decoration: none;
  }

  :focus {
    color: ${theme.colors.primaryBlue};
  }
`;
const ProductDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  margin-top: 6px;
  letter-spacing: -0.24px;
  color: ${theme.colors.black65};
  max-width: ${({
  $maxWidth
}) => $maxWidth ? `${$maxWidth}px` : "auto"};
  direction: ${({
  $direction
}) => $direction && `${$direction}`};

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    margin: 4px auto 12px;
    font-size: 12px;
  }
`;
const SelectFromAboveIsStuckContainer = styled.div`
  display: none;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;

  ${({
  $isStuck
}) => $isStuck && css`
      display: flex;
    `}
`;
const SelectFromAboveIsStuck = styled(ProductDescription)`
  margin: 0;
`;
const ProductNote = styled.div`
  color: ${theme.colors.black45};
  font-size: ${theme.font.size10};
  line-height: 16.8px;
  margin-top: 6px;
  text-align: center;
`;
const Badge = styled(Badge$1)`
  margin: 10px 0 20px;
`;
const BadgeWrapper = styled.div`
  margin-top: auto;
  display: flex;
  gap: 10px;
`;
const PropertyTitleGridItem = styled(StickyGridItem)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid ${theme.colors.athensGreyDark};
  background: ${theme.colors.white};
  z-index: 1;
  overflow: hidden;
`;
const EmptyPropertyTitleGridItem = styled(StickyGridItem)`
  background: ${theme.colors.white};
`;
const PropertyTitleGridItemContent = styled(StickyGridItem)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 16px 16px 8px;
  width: 100%;
  gap: 8px;
  overflow: hidden;
`;
const PropertyTitle = styled.div`
  font-size: 14px;
  font-weight: ${theme.fontWeight.bold};
  color: ${theme.colors.black65};
  line-height: 16.8px;
  letter-spacing: -0.28px;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 12px;
    line-height: 14px;
  }
`;
const PropertyIcon = styled.div`
  width: 30px;
  height: 30px;
  color: ${theme.colors.shark};
`;
const SelectFromAboveIconCopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 1;

  ${({
  $isStuck
}) => $isStuck && css`
      opacity: 0;
    `}
`;
const ProductImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  -webkit-user-drag: none;
`;
const ProductImageWrap = styled.div`
  height: ${({
  height
}) => `${height}px`};
  display: flex;
`;
const PropertyTooltipHoverArea = styled.div`
  position: absolute;
  height: 35px;
  width: 35px;
  top: 50%;
  transform: translateY(-50%);
`;
const PropertyTooltip = styled.div`
  position: relative;
  height: 20px;
`;
const PropertyTooltipContent = styled.div`
  color: ${theme.colors.black85};
  font-size: 12px;

  a {
    color: ${theme.colors.primaryBlue};
  }
`;
const TooltipIcon = styled(StyleableSvgImage)`
  color: ${theme.colors.primaryBlue};
`;
const ButtonWrap = styled.div`
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const buttonStyles = css`
  padding: 10px 15px;
  line-height: 20px;
  font-weight: ${theme.fontWeight.bold};
  margin: auto;
  :focus,
  :hover {
    text-decoration: none;
  }

  > * {
    position: static;
  }
`;
const Button = styled(Button$1)`
  ${buttonStyles};

  ${({
  $removePointerEvents
}) => $removePointerEvents && css`
      pointer-events: none;
    `}
`;
const ComingSoon = styled(Button$1)`
  ${buttonStyles};

  cursor: default;
  color: #445178;

  :focus,
  :hover {
    color: #445178;
  }
`;
const NotesWrap = styled.div`
  padding: 16px 10px 10px;
  text-wrap: pretty;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Note = styled.div`
  font-size: 10px;
  line-height: ${17 / 10};
  color: ${theme.colors.black45};
  text-align: center;
`;
const FootnotesWrap = styled.div`
  padding: 0 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Footnote = styled.div`
  font-size: 10px;
  line-height: ${17 / 10};
  color: ${theme.colors.black45};
  text-align: center;
`;
const KitIncluded = styled.div`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.28px;
  line-height: 16.8px;
  color: ${theme.colors.black65};
`;
const TooltipStyles = createGlobalStyle`
  .${TOOLTIP_CLASS_NAME} {
    box-shadow: 0 8px 24px 0 #00000014;
    max-width: ${({
  maxWidth
}) => maxWidth ?? 200}px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    padding: 8px 16px;
    margin-top: -1.5px;
    background: ${theme.colors.white};

    &::before {
      box-shadow: 0 8px 24px 0 #00000014;
      background: ${theme.colors.white};
    }
  }
`;
export { Badge, BadgeWrapper, Button, ButtonWrap, CenterPlaceholderGridItem, ComingSoon, EmptyHeaderEmptyProductDescription, EmptyHeaderGridItem, EmptyPropertyTitleGridItem, Footnote, FootnotesWrap, HEADER_GRID_ITEM_GAP_DESKTOP, HEADER_GRID_ITEM_GAP_MOBILE, HEADER_GRID_ITEM_Y_PADDING, HeaderGridItem, HeaderGridItemContainer, KitIncluded, MOBILE_BREAKPOINT, Note, NotesWrap, PRODUCT_HEADER_TOOLTIP_CLASSNAME, PlaceholderGridItem, ProductDescription, ProductHeaderTooltipHoverArea, ProductHeaderTooltipLink, ProductHeaderTooltipStyles, ProductImage, ProductImageWrap, ProductMeta, ProductNote, ProductTitle, ProductTitleLink, PropertyIcon, PropertyTitle, PropertyTitleGridItem, PropertyTitleGridItemContent, PropertyTooltip, PropertyTooltipContent, PropertyTooltipHoverArea, RemoveProductButton, SelectFromAboveIconCopyContainer, SelectFromAboveIsStuck, SelectFromAboveIsStuckContainer, TOOLTIP_CLASS_NAME, TooltipIcon, TooltipStyles };
//# sourceMappingURL=CompareTable.styles.mjs.map
